




















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import $ from "jquery";
import "select2";
import "select2/dist/css/select2.min.css";

@Component({
  name: "qSelect2",
  components: {},
  directives: {},
})
export default class qSelect2 extends Vue {
  @Prop()
  value;
  @Prop({
    default: () => {
      return [];
    },
  })
  options: [];
  @Prop({
    default: () => {
      return {};
    },
  })
  config: any;

  mounted() {
    console.log(this.options);

    // const _self = this;
    const setting = { width: "400px", data: this.options, ...this.config };
    $(this.$el)
      // init select2
      .select2(setting)
      .val(this.value)
      .trigger("change")
      // emit event on change.
      .on(
        "select2:select",
        function (error) {
          console.log("select2:select", this);
          const data = error.params.data;
          this.$emit("selected", data.text);
          this.$emit("input", data.id);
          console.log(data);
        }.bind(this)
      );
  }

  destroyed() {
    $(this.$el).off().select2("destroy");
  }

  @Watch("value")
  updateValue(value) {
    // update value
    $(this.$el).val(value).trigger("change");
  }

  @Watch("options")
  updateOptions(value) {
    // update value
    const setting = { width: "400px", data: value, ...this.config };
    $(this.$el).empty().select2(setting);
    $(this.$el).val(this.value).trigger("change");
  }
}
